import { SET_FORM_STATE } from '../actions/IncidentCellListActions.js';

const initialState = {
	remove: []
};

const IncidentCellListReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							remove: action.remove
						};
					}
					default: {
						return state;
					}
	}
};

export default IncidentCellListReducer;
